
export default class TalkSessionForm{

    constructor(){
        this._init();
    }

    _init(){
        this._setChoiceValidate();
    }

    _setChoiceValidate(){
        const firstChoiceSelect = document.querySelector('.form__item.-firstChoice select');
        const secondChoiceSelect = document.querySelector('.form__item.-secondChoice select');

        firstChoiceSelect.addEventListener('change',()=>{
            this._updateSelectOptions(firstChoiceSelect.value, secondChoiceSelect);
        });

        secondChoiceSelect.addEventListener('change',()=>{
            this._updateSelectOptions(secondChoiceSelect.value, firstChoiceSelect);
        });
    }
    
    _updateSelectOptions(selectedChoice, otherSelect) {
        
        for(let i = 0; i < otherSelect.options.length; i++){
            otherSelect.options[i].disabled = false;
        }
        
        if(selectedChoice){
            const optionToDisable = otherSelect.querySelector(`option[value="${selectedChoice}"]`);
            if(optionToDisable) optionToDisable.disabled = true;
        }
    }
}